import { DASHBOARD_DEFAULT_COLOR } from 'fabscale-app/models/dashboard-config';

export default function dashboardGetColorOrDefault(color?: string) {
  return color || DASHBOARD_DEFAULT_COLOR;
}
